import React, {Component} from 'react';
import './Spinner.css';
import Octicon, {Sync} from '@githubprimer/octicons-react';

class Spinner extends Component {
    render() {
        var message = '';
        if(this.props.message !== '') {
             message = <p className="waiting-message">{this.props.message}</p>;
        }
        if(this.props.inline) {
            return <div className="spinner inline">
                {message}
                <div className="spinning">
                    <Octicon icon={Sync} />
                </div>
            </div>;
        }else{
            return <div className="spinner">
                {message}
                <div className="spinning">
                    <Octicon icon={Sync} />
                </div>
            </div>;
        }
    }
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/Components/Elements/Spinner/Spinner.js